























































































































































































































































































































































































import { idtify } from "@/helpers/string";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
// helpers
//import { idtify } from "@/helpers/string";
// tipos
//import { Rutas } from "@/typings/store/modules/rutas";
//import {
//  Permisos,
//  TipoUsuario,
//  Usuario,
//} from "@/typings/store/plugins/easyFirestore/usuarios";
import {
  CajaChica,
  //Bancos
} from "@/typings/store/plugins/easyFirestore/cajaChicas";
// validaciones
import {
  // email,
  required,
} from "vuelidate/lib/validators";
import { DataFormularioCajaChica } from "@/typings/components/cajaChicas/formulario";
import SVGIcon from "@/components/SVGIcon.vue";

import { Archivo, Archivos } from "@/typings/store/modules/archivos";
import VistaPreviaPdf from "@/components/VistaPreviaPdf.vue";
import { imagenFileAPdf } from "@/helpers/imagenAPdf";

@Component({
  components: {
    SVGIcon,
    VistaPreviaPdf,
  },
  validations: {
    // nombre: { required },
    // posicion: { required },
    fecha: { required },
    rutProveedor: { required },
    nombreProveedor: { required },
    accion: { required },
    documento: { required },
    concepto: { required },
    descripcion: { required },
  },
})
export default class FormularioCajaChica extends Vue {
  @Prop() readonly cajaChica!: CajaChica | null;
  @Prop() readonly cargando!: boolean;
  @Prop() readonly totalItems!: number;
  @Prop() readonly total!: number;
  //   @Prop() readonly rutas!: Rutas;
  //   @Prop() readonly ciudades!: Ciudad[];
  //   @Prop() readonly cargando!: boolean;
  //   @Prop() readonly regiones!: Region[];

  // created(): void {
  //   const cajaChica = this.cajaChica;
  //   if (!cajaChica) {
  //     const today = new Date();
  //     const mes = String(today.getMonth() + 1).padStart(2, "0");
  //     const anio = today.getFullYear();
  //     this.periodo = `01-${mes}-${anio}`;
  //     return;
  //   }

  //   this.id = cajaChica.id ?? "";
  //   this.periodo = cajaChica.periodo ?? "";
  //   this.fechaDocumento = cajaChica.fecha.toDate().format("YYYY-MM-DD") ?? "";

  // }

  created(): void {
    // Object.keys(this.rutas).forEach((key) => {
    //   this.$set(this.permisos, key, false);
    // });
    // console.log(this.permisos);
    const cajaChica = this.cajaChica;
    if (!cajaChica) {
      const today = new Date();
      const mes = String(today.getMonth() + 1).padStart(2, "0");
      const anio = today.getFullYear();
      this.periodo = `01-${mes}-${anio}`;
      return;
    }
    this.id = cajaChica.id ?? "";
    this.periodo = cajaChica.periodo ?? "";
    // this.nombre = cajaChica.nombre;
    // this.posicion = cajaChica.posicion ?? "";
    this.checkbox = cajaChica.checkbox ?? false;
    this.numero = cajaChica.numero;
    this.fecha = cajaChica.fecha.toDate().format("YYYY-MM-DD") ?? "";
    this.saldoActual = cajaChica.saldoActual;
    this.rutProveedor = cajaChica.rutProveedor ?? "";
    this.nombreProveedor = cajaChica.nombreProveedor ?? "";
    this.accion = cajaChica.accion ?? "";
    this.ingreso = cajaChica.ingreso ?? "";
    this.egreso = cajaChica.egreso ?? "";
    this.documento = cajaChica.documento ?? "";
    this.concepto = cajaChica.concepto ?? "";
    this.descripcion = cajaChica.descripcion ?? "";
    this.archivo = Object.values(cajaChica.archivo ?? {})[0] ?? null;
  }

  id: string | null = null;

  // nombre = "";
  // posicion = "";
  periodo = "";
  numero = 0;
  fecha = "";
  saldoActual = 0;
  rutProveedor = "";
  nombreProveedor = "";
  accion = "";
  ingreso = "";
  egreso = "";
  documento = "";
  concepto = "";
  descripcion = "";

  archivo?: Archivo | null = null;
  archivosBorrar: Archivos = {};

  vistaPrevia = {
    model: false,
    url: "",
  };

  menu = false;
  checkbox = false;

  itemsAccion = ["ABONAR", "PAGAR", "SALDO PERIODO ANTERIOR"];
  itemsDocumento = [
    "SALDO INICIAL",
    "SALDO PERIODO ANTERIOR",
    "BOLETA DE PAGO",
    "C. DE CREDITO FISCAL",
    "FACTURA COMERCIAL",
    "NOTA DE CREDITO",
    "NOTA DE REVISIÓN",
    "NOTA DE ENVIO",
  ];

  optionsCosto = {
    locale: "es-CL",
    prefix: "$",
    suffix: "",
    length: 18,
    precision: 0,
    allowNegative: true,
  };

  convirtiendoFoto = false;

  get numeroDato(): number {
    let numero = this.totalItems + 1;

    return numero;
  }

  get titulo(): string {
    return this.cajaChica
      ? "Editar Dato de Caja Chica"
      : "Nuevo Dato de Caja Chica";
  }

  get verificaNumero(): number {
    let numeroVerificar = this.numero;
    if (this.numero === 0) {
      numeroVerificar = this.numeroDato;
      return numeroVerificar;
    } else {
      return this.numero;
    }
  }

  get verificaSaldoActual(): number {
    let saldoActualVerificar = this.saldoActual;
    if (this.saldoActual === 0 && this.verificaNumero !== 0) {
      saldoActualVerificar = this.total;
      return saldoActualVerificar;
    } else {
      return this.saldoActual;
    }
  }

  toggleStaFidelmira(): void {
    this.checkbox = !this.checkbox;
    if (this.checkbox) {
      this.rutProveedor = "79.991.280-5";
      this.nombreProveedor = "INVERSIONES SANTA FIDELMIRA S.A";
    }
  }

  @Watch("accion")
  onAccionChanged(newVal: string): void {
    if (newVal === "ABONAR" || newVal === "SALDO PERIODO ANTERIOR") {
      this.egreso = "";
    } else if (newVal === "PAGAR") {
      this.ingreso = "";
    }
  }

  // get verificaNombreProveedor(): string {
  //   if (this.checkbox === true) {
  //     this.nombreProveedor = "INVERSIONES SANTA FIDELMIRA S.A";
  //     return this.nombreProveedor;
  //   } else {
  //     this.nombreProveedor = "";
  //     return "";
  //   }
  // }

  //   get permisosKey(): Array<string> {
  //     // return Object.keys(this.permisos).filter((key) => {
  //     //   if(this.rutas[key].tipos.includes(this.tipo)){
  //     //     this.permisos[key] = true;
  //     //   }
  //     // });
  //     return Object.keys(this.permisos).filter((key) => {
  //       if (!this.rutas[key]) {
  //         return false;
  //       }
  //       const tipo = this.rutas[key].tipos.includes(this.tipo);
  //       return tipo;
  //     });
  //   }

  /////////////////////////////////
  get importeIngreso(): string {
    let importe = this.ingreso;
    if (importe === "") {
      return "0";
    }
    return importe;
  }

  get importeEgreso(): string {
    let importe = this.egreso;
    if (importe === "") {
      return "0";
    }
    return importe;
  }

  get numeroAuto(): number {
    return this.cajaChica?.numero ?? 0;
  }

  get fechaError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.fecha.$dirty) return errors;
    if (!this.$v.fecha.required) errors.push("Indica la fecha");
    return errors;
  }

  get rutProveedorError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.rutProveedor.$dirty) return errors;
    if (!this.$v.rutProveedor.required) errors.push("Indica el RUT del proveedor");
    return errors;
  }

  get nombreProveedorError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.nombreProveedor.$dirty) return errors;
    if (!this.$v.nombreProveedor.required) errors.push("Indica el nombre del proveedor");
    return errors;
  }

  get accionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.accion.$dirty) return errors;
    if (!this.$v.accion.required) errors.push("Selecciona una acción");
    return errors;
  }

  get documentoError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.documento.$dirty) return errors;
    if (!this.$v.documento.required) errors.push("Selecciona el documento");
    return errors;
  }

  get conceptoError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.concepto.$dirty) return errors;
    if (!this.$v.concepto.required) errors.push("Indica el concepto");
    return errors;
  }

  get descripcionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.descripcion.$dirty) return errors;
    if (!this.$v.descripcion.required) errors.push("Indica la descripción");
    return errors;
  }

  @Emit("close")
  onClose(): null {
    return null;
  }

  @Emit("cerrar-dialogo")
  onCerrarDialogo(): void {
    return;
  }

  @Emit("click-guardar")
  onClickGuardar(data: DataFormularioCajaChica): DataFormularioCajaChica {
    return data;
  }

  //   @Watch("permisosKey", { immediate: true })
  //   onTipoChange(): void {
  //     console.log("a");
  //     for (const key of Object.keys(this.permisos)) {
  //       if (this.permisos[key]) {
  //         this.permisos[key] = false;
  //       }
  //     }
  //     this.permisosKey.forEach((key) => {
  //       this.permisos[key] = true;
  //     });
  //   }

  //   nombrePermiso(key: string): string {
  //     return this.rutas[key].text;
  //   }
  get nombreArchivo(): string {
    return this.archivo?.file?.name ?? this.archivo?.nombre ?? "";
  }

  cargarArchivo(ev: Event): void {
    const input = ev.target as HTMLInputElement;
    const file = input?.files ? input.files[0] : null;
    if (file) {
      if (file.type.includes("pdf")) {
        const fecha = new Date();
        const extencion = file.name.split(".").pop() ?? "";
        const id = `cajaChicas/${
          this.verificaNumero
        }/archivo/${fecha.valueOf()}.${extencion}`;
        this.archivo = {
          id: id,
          nombre: file.name,
          file: file,
        };
      }
    }
  }

  clickInputArchivo(): void {
    const input = this.$refs.inputArchivo as HTMLInputElement;
    if (input) input.click();
  }

  clickInputTomarFoto(): void {
    const input = this.$refs.inputTomarFoto as HTMLInputElement;
    if (input) {
      input.value = "";
      input.click();
    }
  }

  clickInputSubirImagen(): void {
    const input = this.$refs.inputSubirImagen as HTMLInputElement;
    if (input) {
      input.value = "";
      input.click();
    }
  }

  async cargarFotoComoPdf(ev: Event): Promise<void> {
    const input = ev.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file || !file.type.startsWith("image/")) return;
    this.convirtiendoFoto = true;
    try {
      const blob = await imagenFileAPdf(file);
      const fecha = new Date();
      const nombrePdf = `documento-foto-${fecha.valueOf()}.pdf`;
      const id = `cajaChicas/${this.verificaNumero}/archivo/${fecha.valueOf()}.pdf`;
      const pdfFile = new File([blob], nombrePdf, { type: "application/pdf" });
      this.archivo = {
        id,
        nombre: nombrePdf,
        file: pdfFile,
      };
    } catch {
      this.$emit("error-foto-pdf");
    } finally {
      this.convirtiendoFoto = false;
      if (input) input.value = "";
    }
  }

  abrirVistaPrevia(archivo: Archivo): void {
    this.vistaPrevia = {
      model: true,
      url: this.urlArchivo(archivo),
    };
  }

  cerrarVistaPrevia(): void {
    this.vistaPrevia = {
      model: false,
      url: "",
    };
  }

  eliminarArchivo(): void {
    if (this.cajaChica && this.archivo?.id) {
      this.archivosBorrar[this.archivo.id] = this.archivo;
    }
    this.archivo = null;
  }

  urlArchivo(media: Archivo): string {
    if (media.url) return media.url;
    if (media.file) return URL.createObjectURL(media.file);
    return "";
  }

  guardar(): void {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }
    const doc: CajaChica = {
      periodo: this.periodo,
      checkbox: this.checkbox,
      numero: this.verificaNumero,
      fecha: this.fecha.toDate().format("DD-MM-YYYY") ?? "",
      saldoActual: this.verificaSaldoActual,
      rutProveedor: this.rutProveedor.toUpperCase(),
      nombreProveedor: this.nombreProveedor.toUpperCase(),
      accion: this.accion,
      ingreso: this.importeIngreso,
      egreso: this.importeEgreso,
      documento: this.documento,
      concepto: this.concepto,
      descripcion: this.descripcion.toUpperCase(),
    };
    if (this.id) {
      doc.id = this.id;
    }
    const data: DataFormularioCajaChica = {
      doc: doc,
      borrar: this.archivosBorrar,
      archivo: {},
    };
    if (this.archivo) {
      data.archivo = {
        [idtify(this.archivo.id)]: this.archivo,
      };
    }
    this.onClickGuardar(data);
  }
}
